import { render, staticRenderFns } from "./FulfillmentKomshipDetail.vue?vue&type=template&id=46dc87b2&scoped=true&"
import script from "./FulfillmentKomshipDetail.vue?vue&type=script&lang=js&"
export * from "./FulfillmentKomshipDetail.vue?vue&type=script&lang=js&"
import style0 from "./FulfillmentKomshipDetail.vue?vue&type=style&index=0&id=46dc87b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dc87b2",
  null
  
)

export default component.exports